import React, { useContext } from 'react'
import Provider, { WordBankSelectContextProvider } from './Provider'
import { IProps } from './Interface'
import { palette } from 'config'
import { IWordBank, WordBankCategory } from 'types'
import { WordBank, WordBankCreate } from 'components'
import { Box, Typography } from '@material-ui/core'
import useStyles from './Styles'

const WordBankSelect: React.FC<IProps> = ({
  title,
  color,
  maxTagsNum,
  selectedWordBanks,
  category,
  disabled,
  canAddNewTag,
  handleAddOwnClick,
  handleWordBankClick
}) => {
  const {
    state: { subTypes, isTalentTag, wordBanks, ref }
  } = useContext(WordBankSelectContextProvider)
  const classes = useStyles({ color })

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography id="word-bank-select-title-label" variant="body1" className={classes.title}>
          {title}
        </Typography>
        <Typography id="word-bank-select-count-label" variant="body1" className={classes.count}>
          {selectedWordBanks.length} of {maxTagsNum} selected
        </Typography>
      </Box>
      <Box className={classes.content} ref={ref}>
        <Box className={classes.wordBanksContainer}>
          {wordBanks.map((wordbank: IWordBank) => (
            <WordBank
              key={wordbank._id}
              color={color}
              category={category}
              className={classes.wordbank}
              label={wordbank.value}
              status={wordbank.status}
              selected={selectedWordBanks.indexOf(wordbank._id) !== -1}
              onClick={() => !disabled && handleWordBankClick(wordbank)}
            />
          ))}
          {!disabled && (
            <WordBankCreate
              color={color}
              title={title}
              isTalentTag={isTalentTag}
              className={classes.wordbank}
              shouldRender={canAddNewTag}
              categories={subTypes}
              onAddOwnClick={handleAddOwnClick}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

WordBankSelect.defaultProps = {
  title: '',
  page: 0,
  color: palette.common.purple,
  category: WordBankCategory.CompanyDescriptor,
  pageLength: 20,
  maxTagsNum: 5,
  wordBanks: [],
  selectedWordBanks: [],
  disabled: false,
  canAddNewTag: () => false,
  handleAddOwnClick: () => {},
  handleWordBankClick: () => {}
}

export default (props: IProps) => (
  <Provider {...props}>
    <WordBankSelect {...props} />
  </Provider>
)
